import { render, staticRenderFns } from "./deliverStat.vue?vue&type=template&id=19547181&"
import script from "./deliverStat.vue?vue&type=script&lang=js&"
export * from "./deliverStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "deliverStat.vue"
export default component.exports